(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3086],{

/***/ 17345:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[model]",
      function () {
        return __webpack_require__(40477);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var common_SeoMetaData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25384);
/* harmony import */ var components_shopFeatures_auth_authRepository__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12785);
/* harmony import */ var components_shopFeatures_auth_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42210);
/* harmony import */ var components_shopFeatures_showRooms_showRoomsSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47192);
/* harmony import */ var components_shopFeatures_wizard_Wizard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64633);
/* harmony import */ var layout_oldLayout_ShopLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14682);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73727);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13328);











var Router =  true ? function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_8__/* .HashRouter */ .UT, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props));
} : 0;
var Model = function(param) {
    var seo = param.seo;
    //  todo gil there is a problem here:
    var dispatch = (0,store__WEBPACK_IMPORTED_MODULE_7__/* .useAppDispatch */ .TL)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        dispatch((0,components_shopFeatures_auth_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .initAuth */ .Z5)(components_shopFeatures_auth_authRepository__WEBPACK_IMPORTED_MODULE_10__/* .getToken */ .LP()));
        dispatch((0,components_shopFeatures_showRooms_showRoomsSlice__WEBPACK_IMPORTED_MODULE_3__/* .fetchShowRooms */ .j)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(common_SeoMetaData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layout_oldLayout_ShopLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Router, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shopFeatures_wizard_Wizard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Model);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,7191,4245,2669,4856,7322,6034,273,8375,4839,5181,4021,2073,9774,2888,179], function() { return __webpack_exec__(17345); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);